/**
 * useApplyClubBrand — writes the club's brand color to `--club-avatar-color`
 * on documentElement. Scope is intentionally narrow: only the club avatar
 * (sidebar `.brand-chip` + the picker badge) reads this token. Buttons,
 * focus rings, active nav, and every other accent surface keep using
 * `--accent` (the theme default) so the rest of the app stays visually
 * consistent across clubs.
 *
 * Earlier this hook overrode `--accent` globally, which cascaded into every
 * accent surface. The product call (April 2026) is to keep that variation
 * confined to the club avatar so brand color reads as identity, not theme.
 */

import { useEffect } from 'react'

export function applyClubBrand(accentColor: string | null | undefined): void {
  const root = document.documentElement
  if (!accentColor) {
    root.style.removeProperty('--club-avatar-color')
    return
  }
  root.style.setProperty('--club-avatar-color', accentColor)
}

/** React effect that re-applies the brand color whenever it changes. */
export function useApplyClubBrand(accentColor: string | null | undefined): void {
  useEffect(() => {
    applyClubBrand(accentColor)
  }, [accentColor])
}
